import { AchievementsListComponent } from '@1bill-app/components/achievements-list/achievements-list.component';
import { ActionCardsComponentModule } from '@1bill-app/components/action-cards/action-cards.module';
import { BestDealCardsComponentModule } from '@1bill-app/components/best-deal-cards/best-deal-cards.module';
import { BillsDueCardComponentModule } from '@1bill-app/components/bills-due-card/bills-due-card.module';
import { ComparisonResultsCardsComponent } from '@1bill-app/components/comparison-results-cards/comparison-results-cards.component';
import { PopoverUpdateBalanceComponent } from '@1bill-app/components/popover/popover-update-balance/popover-update-balance.component';
import { SharedComponentsModule } from '@1bill-app/components/shared-components.module';
import { PipesModule } from '@1bill-app/pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BillProcessingBlockComponent } from './bill-processing-block/bill-processing-block.component';
import { CompleteProfileComponent } from './complete-profile/complete-profile.component';
import { LatestBillsComponent } from './latest-bills/latest-bills.component';
import { HomePageRoutingModule } from './tab-home-routing.module';
import { TabHomePage } from './tab-home.page';
import { UpcomingBillsModule } from './upcoming-bills/upcoming-bills.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    SharedComponentsModule,
    ActionCardsComponentModule,
    BillsDueCardComponentModule,
    BestDealCardsComponentModule,
    UpcomingBillsModule,
    PipesModule
  ],
  declarations: [
    TabHomePage,
    BillProcessingBlockComponent,
    ComparisonResultsCardsComponent,
    CompleteProfileComponent,
    AchievementsListComponent,
    LatestBillsComponent,

  ],
})
export class TabHomePageModule { }
